import { get } from '../../api';

const enc = encodeURIComponent;

const getAgentId = (value) => {
  try {
    return Number.parseInt(value, 10);
  } catch (error) {
    return false;
  }
};

const parseSelectedAgents = (filteredAgents, agentNetwork) => {
  let agents = [];
  filteredAgents.forEach((agent) => {
    const agentId = getAgentId(agent.value);
    if (agentId) {
      agents.push(agentId);
    } else {
      agents = agents.concat(findAgentsInNode(agent, agentNetwork));
    }
  });

  return `&$filter=(${agents.map((k) => `AgentId eq ${k}`).join(' or ')})`;
};

const findAgentsInNode = (node, agentNetwork) => {
  const nodeDepth = node._id.split('-');
  let depth = agentNetwork;
  for (let i = 1; i < nodeDepth.length; i++) {
    depth = depth.children[nodeDepth[i]];
  }
  return findNestedAgents(depth);
};

const findNestedAgents = (node) => {
  let agents = [];
  node.children.forEach((child) => {
    const agentId = getAgentId(child.value);
    if (agentId) {
      agents.push(agentId);
    } else {
      agents = agents.concat(findNestedAgents(child));
    }
  });
  return agents;
};

const parseAgents = (odataQuery, agents, agentNetwork) => {
  if (!agents.length) {
    return odataQuery;
  }
  return parseSelectedAgents(agents, agentNetwork);
};

const concatToOdata = (odataQuery, filter) => {
  return `${
    odataQuery.includes('$filter') ? ` and ${filter}` : `&$filter=${filter}`
  }`;
};

const isGroupedBy = (query) => {
  return query.groupAgent || query.groupProduct || query.groupStatus;
};

const cutLastComma = (query) => {
  return query.slice(0, query.length - 1);
};

const getOdataQuery = (query) => {
  let odataQuery = `?agentId=${enc(query.agentId)}`;
  if (query.agents && query.agents.length && query.agents[0].value !== 'all') {
    odataQuery += parseAgents(odataQuery, query.agents, query.agentNetwork[0]);
  }
  if (query.startDate) {
    const filterStartDate = `DateSent gt ${enc(query.startDate)}`;
    odataQuery += concatToOdata(odataQuery, filterStartDate);
  }
  if (query.endDate) {
    const filterEndDate = `DateSent lt ${enc(query.endDate)}`;
    odataQuery += concatToOdata(odataQuery, filterEndDate);
  }
  if (query.product) {
    const filterProduct = `Product eq '${enc(query.product)}'`;
    odataQuery += concatToOdata(odataQuery, filterProduct);
  }
  if (query.status === 'contract') {
    const filterStatus = 'ContractId gt 0';
    odataQuery += concatToOdata(odataQuery, filterStatus);
  }
  if (query.status === 'pending') {
    const filterStatusPending = 'ContractId eq null';
    odataQuery += concatToOdata(odataQuery, filterStatusPending);
  }
  if (query.top && !isGroupedBy(query)) {
    odataQuery += `&$top=${enc(query.top)}`;
  }
  if (isGroupedBy(query)) {
    let groupByQuery = '';
    let orderByQuery = '&$orderby=';

    if (query.groupAgent) {
      groupByQuery += 'AgentId, Name, Surname,';
      orderByQuery += 'Name,';
    }
    if (query.groupProduct) {
      groupByQuery += 'Product,';
      orderByQuery += 'Product,';
    }
    if (query.groupStatus) {
      groupByQuery += 'HasContract,';
      orderByQuery += 'HasContract,';
    }
    groupByQuery = cutLastComma(groupByQuery);
    orderByQuery = cutLastComma(orderByQuery);

    odataQuery += `&$apply=groupby((${groupByQuery}),aggregate($count as Ammount))`;
    odataQuery += orderByQuery;
  } else {
    odataQuery += '&$orderby=DateSent desc';
  }
  return odataQuery;
};

const getAgentBudgets = (args) => {
  return get({
    api: `api/budget/track/correduria${getOdataQuery(args)}`,
  });
};

const getAgentAllowProducts = async (agentId) => {
  const response = await get({
    api: `api/contract/productosPermitidos?agentId=${enc(agentId)}`,
  });

  return response;
};

const getAgentNetwork = async (agentId) => {
  let agentNetwork = [];

  const response = await get(
    {
      api: `api/mediation/agents/network?agentId=${enc(agentId)}`,
    },
    { network: true }
  );

  if (response.length) {
    agentNetwork.push({
      label: 'Todos los agentes',
      value: 'all',
      children: [],
    });
  }
  response.forEach((territorialOffice) => {
    let territory = {
      label: territorialOffice.territorialAddress,
      value: territorialOffice.territorialAddress,
      children: [],
    };

    territorialOffice.groups.forEach((group) => {
      let groupTerritory = {
        label: group.group,
        value: group.group,
        children: [],
      };

      group.agents.forEach((agent) => {
        groupTerritory.children.push({
          label: `${agent.name} ${agent.lastName}`,
          value: agent.agentId,
        });
      });

      territory.children.push(groupTerritory);
    });

    agentNetwork[0].children.push(territory);
  });

  return agentNetwork;
};

export { getAgentBudgets, getAgentNetwork, getAgentAllowProducts };



// WEBPACK FOOTER //
// ./src/components/SentBudgets/agentBudgets.js